import { ShieldCheck } from 'lucide-react';

const AuthenticatingSpinner = () => {
    return (
        <div className="flex items-center justify-center min-h-screen bg-background">
            <div className="flex flex-col items-center gap-6">
                <div className="relative flex items-center justify-center">
                    <div className="absolute inset-0 animate-ping opacity-20">
                        <div className="w-20 h-20 rounded-full bg-primary/20" />
                    </div>
                    <div className="relative">
                        <ShieldCheck
                            size={56}
                            className="text-primary animate-pulse"
                            strokeWidth={1.5}
                        />
                    </div>
                </div>
                <div className="flex flex-col items-center gap-2">
                    <h2 className="text-lg font-semibold text-foreground">Authenticating</h2>
                    <p className="text-sm text-muted-foreground">Verifying your credentials...</p>
                </div>
            </div>
        </div>
    );
};

export default AuthenticatingSpinner;
